module.exports = __webpack_public_path__ + "static/media/radial.37e5537e.svg";